import React from 'react'

const CouponTick = () => (
  <svg
    height="19"
    viewBox="0 0 24 19"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" fillRule="evenodd">
      <g fill="#287D3C" fillRule="nonzero">
        <g>
          <path
            d="M272.496 63.496c-.53-.002-1.037-.214-1.41-.59l-5.5-5.5c-.781-.781-.781-2.048 0-2.83.782-.781 2.049-.781 2.83 0l4.09 4.09 13.08-13.08c.782-.781 2.049-.781 2.83 0 .782.782.782 2.049 0 2.83l-14.5 14.5c-.377.374-.888.583-1.42.58z"
            transform="translate(-279 -510) translate(14 465)"
          />
        </g>
      </g>
    </g>
  </svg>
)

export default CouponTick
